import { Breadcrumbs } from "@/components/common/Breadcrumbs";

export function PageHero({ overline, title, description, breadcrumbs, children }) {
  return (
    <section className="relative overflow-hidden bg-navy">
      <div className="absolute inset-0 grid-lines opacity-60" />
      <div className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-finblue/20 blur-3xl" />
      <div className="container-tight relative py-16 lg:py-20">
        {breadcrumbs && (
          <div className="[&_a]:text-slate-400 [&_a:hover]:text-gold [&_span]:text-white [&_.text-subtle\\/60]:text-slate-600">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}
        {overline && <p className="overline mb-3 text-gold">{overline}</p>}
        <h1 className="max-w-3xl font-heading text-4xl font-bold tracking-tight text-white lg:text-5xl">{title}</h1>
        {description && <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">{description}</p>}
        {children}
      </div>
    </section>
  );
}
